// extracted by mini-css-extract-plugin
export var pitchPinkBackgroundColor = "colors-module__pitchPinkBackgroundColor___QT13f";
export var pitchPinkColor = "colors-module__pitchPinkColor___9mfoe";
export var pitchPinkFillColor = "colors-module__pitchPinkFillColor___GMAII";
export var pitchPinkHoverBackgroundColor = "colors-module__pitchPinkHoverBackgroundColor___LqS8L";
export var xboxGreen = "#107C10";
export var xboxGreenBackgroundColor = "colors-module__xboxGreenBackgroundColor___Hs78U";
export var xboxGreenColor = "colors-module__xboxGreenColor___kK9r1";
export var xboxGreenFillColor = "colors-module__xboxGreenFillColor___coOjO";
export var xboxGreenHoverBackgroundColor = "colors-module__xboxGreenHoverBackgroundColor___F9A9c";